module.exports = __webpack_public_path__ + "img/incident_medico_selected.1ff6c90d.svg";